import { FILTER_LABELS } from '@screens/Category/config/filters';

export const getFilterLabel = (filterId: string, name: string) => {
  if (FILTER_LABELS[filterId]) {
    return FILTER_LABELS[filterId];
  }

  return name;
};
